export const card = {
  root: {
    shadow: 'none',
    borderRadius: '{form.field.border.radius}',
  },
  body: {
    padding: '1rem',
  },
};
